import { Twitter } from '@transferwise/icons';
import PropTypes from 'prop-types';
import React from 'react';

import componentStyles from '../SocialSharing.module.less';

const generateLink = (details) => {
  const hashtags = details.hashtags.join(',');
  const uri = `text=${details.text}&hashtags=${hashtags}`;
  return `https://twitter.com/intent/tweet?${encodeURI(uri)}`;
};

const generateOnClick = (onClickToShare, details) => {
  if (onClickToShare) {
    onClickToShare();
  }

  window.open(generateLink(details), '_blank');
};

const TwitterShareButton = ({ style, iconStyle, sharingDetails }) => (
  <button
    type="button"
    className={`${componentStyles['btn--circle']}`}
    style={style}
    onClick={() => {
      generateOnClick(sharingDetails.onClickToShare, sharingDetails);
    }}
  >
    <Twitter size={iconStyle.size} />
  </button>
);

TwitterShareButton.propTypes = {
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  iconStyle: PropTypes.shape({
    size: PropTypes.oneOf([16, 24]),
    className: PropTypes.string,
    title: PropTypes.string,
  }),
  sharingDetails: PropTypes.shape({
    text: PropTypes.string.isRequired,
    hashtags: PropTypes.arrayOf(PropTypes.string),
    onClickToShare: PropTypes.func,
  }).isRequired,
};

TwitterShareButton.defaultProps = {
  style: {},
  iconStyle: {
    size: 24,
    className: '',
    title: '',
  },
};

export default TwitterShareButton;
